import { Outlet } from 'react-router-dom';

export default function Vacations() {
  return <Outlet />;
}
